import axios from "axios";

export default {
    search(query) {
        return axios
            .get("/api/applications", {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    searchToSchedules(query) {
        return axios
            .get("/api/applications_to_schedule", {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    showApplication(id) {
        return axios.get("/api/application/" + id);
    },

    exportApplications(query) {
        return axios
            .get("/api/applications/export", {
                responseType: "blob",
                params: {
                    search: query.search,
                    fields: query.fields
                }
            })
            .then(function (response) {
                return response;
            });
    },

    statuses() {
        return axios.get("/api/candidate/application/statuses");
    },
    origins() {
        return axios.get("/api/candidate/application/origins");
    },
    updateStatuses(data) {
        return axios.post("/api/candidate/application/statuses/update", data);
    },
    deleteStatus(data) {
        return axios.post("/api/candidate/application/statuses/delete", data);
    },

};
